(function (Drupal, once) {
  Drupal.behaviors.stickySubNavigation = {
    attach(context) {
      once('jump-link-toggle', '.jump-link__toggle', context).forEach(
        (button) => {
          button.addEventListener('click', () => {
            const menu = document.getElementById(
              button.getAttribute('aria-controls')
            );

            const expanded =
              button.getAttribute('aria-expanded') === 'true';

            button.setAttribute('aria-expanded', !expanded);
            menu.classList.toggle('is-open');
            button.classList.toggle('is--active');
          });
        }
      );

      
      document.querySelectorAll('#jump-link-menu a[href^="#"]').forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const stickyNav = document.querySelector('.jump-link__dropdown');
          const stickyButton = document.querySelector('.jump-link__toggle');
          const target = document.querySelector(this.getAttribute('href'));
          stickyNav.classList.remove('is-open');
          stickyButton.setAttribute('aria-expanded', 'false');
          stickyButton.classList.remove('is--active');  
          if (target) {
            const headerOffset = 100; // adjust as needed
            const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      });

      function stickyNav() {
        const nav = document.querySelector('.jump-link');
        console.log("nav", nav);
        if (!nav) return;

        const stickyOffset = nav.offsetTop - 100;
        console.log("stickyOffset", stickyOffset);

        window.addEventListener('scroll', () => {
          if (window.scrollY >= stickyOffset) {
            nav.classList.add('is-sticky');
          } else {
            nav.classList.remove('is-sticky');
          }
        });
      };
      
      document.addEventListener('DOMContentLoaded', stickyNav());


    }
  };
})(Drupal, once);